import { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { listarSuporte } from '../../services/suporte'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import '../../styles/menuopcoes.css'

function MenuSuporte (props: menuOpcoes) {

    const { atualizarInformacoes } = useContext(ModalEstadoContext)

    const { search } = useLocation()
    const paramsUrl = new URLSearchParams(search)
    
    const idProjeto = paramsUrl.get("idProjeto")
    const grupo = paramsUrl.get("grupo")

    const [atendimento, setAtendimento] = useState(0)
    const [bug, setBug] = useState(0)
    const [melhoria, setMelhoria] = useState(0)

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    useEffect(() => {
        
        const buscarSuporte = async () => {

            const paramsSuporte = {
                pagina: 1,
                termo: '',
                tipo: 'suporte',
                status: 'sem análise'
            }

            const paramsBug = {
                pagina: 1,
                termo: '',
                tipo: 'bug',
                status: 'sem análise'
            }

            const paramsSugestao = {
                pagina: 1,
                termo: '',
                tipo: 'sugestão',
                status: 'sem análise'
            }

            const promisses = [
                await listarSuporte(paramsSuporte),
                await listarSuporte(paramsBug),
                await listarSuporte(paramsSugestao)
            ]
            
            try {

                const resposta = await Promise.all(promisses)

                const suporte = resposta[0]
                const bug = resposta[1]
                const sugestao = resposta[2]

                if(suporte.status === 200) {
                    setAtendimento(suporte.data.length)
                }

                if(bug.status === 200) {
                    setBug(bug.data.length)
                }

                if(sugestao.status === 200) {
                    setMelhoria(sugestao.data.length)
                }
                
            } catch (error) {
                
            }
        }

        buscarSuporte ()

    }, [atualizarInformacoes])

    return (
        <div>
            <div id = 'menuOpcoes' onClick={exibirSubmenu}>
                {<img id = 'iconeMenu' src= {props.icone ? `${props.icone}` : ''} alt = {props.alt}></img>}
                <p id = 'tituloMenu'>{props.titulo}</p>
                {(atendimento + bug + melhoria) !== 0 ? <h2>{atendimento + bug + melhoria}</h2> : null}
            </div>
            <div id = 'submenuOpcoes'>
                {subMenu && <SubMenuOpcoes redirect = {`/ajuda?tipo=suporte&idProjeto=${idProjeto}&grupo=${grupo}`} texto = 'Solicitar Atendimento' notificacao={atendimento === 0 ? null : atendimento}/>}
                {subMenu && <SubMenuOpcoes redirect = {`/ajuda?tipo=bug&idProjeto=${idProjeto}&grupo=${grupo}`} texto = 'Reportar Problema' notificacao={bug === 0 ? null : bug}/>}
                {subMenu && <SubMenuOpcoes redirect = {`/ajuda?tipo=sugestão&idProjeto=${idProjeto}&grupo=${grupo}`} texto = 'Sugestão de Melhoria' notificacao={melhoria === 0 ? null : melhoria}/>}
            </div>
        </div>
    )
}

export default MenuSuporte
